import Vue from "vue";
import PosFnbService from "@/services/PosFnbService";
import FnBService from "@/services/Pos_Fnb_Service";
import store from "@/store";

function initialState() {
  return {
    customizationsList: [],
    selectedCustomizations: [],
    selectedChargeableCustomizations: [],
    customizationAdditionalTaxes: [],
    customizationTotalPrice: 0,
    customizationTaxesPrice: 0,
    customizable_item_id: null
  };
}
const state = initialState();
const mutations = {
  SET_CUSTOMIZATION_LIST: (state, payload) => {
    state.customizationsList = payload || [];
  },
  SET_CUSTOMIZABLE_ITEM_ID: (state, payload) => {
    state.customizable_item_id = payload || null;
  },
  ADD_SELECTED_CUSTOMIZATION: (state, payload) => {
    let obj = {
      ...payload,
      fnb_id: state.customizable_item_id
    };
    state.selectedCustomizations.push(obj);
    console.log("state.selectedCustomizations", state.selectedCustomizations);
    state.selectedChargeableCustomizations.push(obj);
  },
  CALCULATE_CUSTOMIZABLE_TOTAL_PRICE: (state, payload) => {
    state.customizationTotalPrice = 0;
    state.selectedCustomizations.map(singleItem => {
      state.customizationTotalPrice += singleItem.fp_total_amount;
      console.log(
        "state.customizationTotalPrice",
        state.customizationTotalPrice
      );
    });
  },
  SET_CUSTOMIZATION_ADDITIONAL_TAXES: (state, payload) => {
    payload.map(x => {
      let listIndex = state.customizationAdditionalTaxes.findIndex(
        z => z.charge_type_id == x.charge_type_id
      );
      if (listIndex == -1) {
        state.customizationAdditionalTaxes.push(x);
      }
      console.log(
        "state.customizationAdditionalTaxes 63",
        state.customizationAdditionalTaxes
      );
    });
    // if (listIndex == -1) {
    //     state.customizationAdditionalTaxes.push(payload[0]);
    // }
    // console.log('state.customizationAdditionalTaxes :>> ', state.customizationAdditionalTaxes);
  },
  CALCULATE_ADDITIONAL_TAXES: (state, payload) => {
    state.customizationTaxesPrice = 0;
    state.customizationAdditionalTaxes.map(x => {
      state.customizationTaxesPrice += x.frcs_amount;
    });
    console.log(
      "state.customizationTaxesPrice 74",
      state.customizationTaxesPrice
    );
  },
  REMOVE_SELECTED_ITEM: (state, payload) => {
    let indexs = [];
    state.customizationAdditionalTaxes.map((tax, index) => {
      if (String(tax.item_id) == String(payload.customization_id)) {
        indexs.push(index);
      }
    });
    for (var i = indexs.length - 1; i >= 0; i--) {
      state.customizationAdditionalTaxes.splice(indexs[i], 1);
    }
    let customizationIndex = state.selectedCustomizations.findIndex(x => {
      return x.customization_id == payload.customization_id;
    });
    if (customizationIndex > -1) {
      state.selectedCustomizations.splice(customizationIndex, 1);
    }
    let customizationChargeableIndex = state.selectedChargeableCustomizations.findIndex(
      x => {
        return x.customization_id == payload.customization_id;
      }
    );
    if (customizationChargeableIndex > -1) {
      state.selectedChargeableCustomizations.splice(
        customizationChargeableIndex,
        1
      );
    }
  },
  RESET_CUSTOMIZATION_STORE: (state, payload) => {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};
const actions = {
  _onFetchCustomization: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_CUSTOMIZATION_LIST", []);
    await commit("SET_CUSTOMIZABLE_ITEM_ID", null);
    PosFnbService.GetCustomizationDetails({
      customization_common_id: payload.customization_common_id
    })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          await commit("SET_CUSTOMIZATION_LIST", data.Records);
          await commit("SET_CUSTOMIZABLE_ITEM_ID", payload.item_id);
          await vmVue.$root.$emit("bv::show::modal", "customization-modal");
        } else {
          data.message
            ? Vue.toasted.show(data.message || "Opps! Something went wrong")
            : "";
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Sorry! Something went wrong. kindly contact your administrator"
        );
      });
  },
  onFetchCustomization: async ({ dispatch, commit, state }, payload) => {
    console.log("onFetchCustomization payload", payload);
    await commit("SET_CUSTOMIZATION_LIST", []);
    await commit("SET_CUSTOMIZABLE_ITEM_ID", null);
    PosFnbService.GetCustomizationDetailsV2({ item_id: payload.item_id })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          await commit("SET_CUSTOMIZATION_LIST", data.Records);
          await commit("SET_CUSTOMIZABLE_ITEM_ID", payload.item_id);
          await vmVue.$root.$emit("bv::show::modal", "customization-modal");
        } else {
          data.message
            ? Vue.toasted.show(data.message || "Opps! Something went wrong")
            : "";
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Sorry! Something went wrong. kindly contact your administrator"
        );
      });
  },
  onSelectCustomization: async ({ dispatch, commit, state }, payload) => {
    let selectedIndex = state.selectedCustomizations.findIndex(x => {
      return (
        x.customization_id == payload.customization_id &&
        x.fnb_id == state.customizable_item_id
      );
    });
    if (selectedIndex == -1) {
      await store.dispatch("ADD_CUSTOMIZATION_TO_ITEM", {
        customization: payload,
        fnb_id: state.customizable_item_id
      });
      await commit("ADD_SELECTED_CUSTOMIZATION", payload);
      if (true) {
        FnBService.GetFnBAdditionalCharges({
          item_id: payload.customization_id
        })
          .then(async response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              await commit("SET_CUSTOMIZATION_ADDITIONAL_TAXES", data.Records);
              await commit("CALCULATE_ADDITIONAL_TAXES");
              await store.dispatch("validateCustomerPoints");
            } else {
              data.message
                ? Vue.toasted.show(data.message || "Opps! Something went wrong")
                : "";
            }
          })
          .catch(error => {
            Vue.toasted.show(
              "Sorry! Something went wrong. kindly contact your administrator"
            );
          });
      }
      await commit("CALCULATE_CUSTOMIZABLE_TOTAL_PRICE", payload);
      await store.dispatch("validateCustomerPoints");
      await vmVue.$root.$emit("bv::hide::modal", "customization-modal");
    } else {
      Vue.toasted.show(
        "You have already added this customization. Please select something else"
      );
    }
  },
  REMOVE_CUSTOMIZATION_FROM_ITEM: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    if (
      payload.hasOwnProperty("customizations") &&
      payload.customizations.length > 0
    ) {
      payload.customizations.map(async x => {
        let customizationIndex = state.selectedCustomizations.findIndex(y => {
          return x.customization_id == y.customization_id;
        });
        if (customizationIndex > -1) {
          await commit(
            "REMOVE_SELECTED_ITEM",
            state.selectedCustomizations[customizationIndex]
          );
          await commit("CALCULATE_CUSTOMIZABLE_TOTAL_PRICE");
          await commit("CALCULATE_ADDITIONAL_TAXES");
          await store.dispatch("validateCustomerPoints");
        }
      });
    }
  },
  REMOVE_SELECTED_CUSTOMIZATON: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("REMOVE_SELECTED_ITEM", payload);
    await commit("CALCULATE_CUSTOMIZABLE_TOTAL_PRICE", payload);
    await store.dispatch("validateCustomerPoints");
  },
  ResetCustomizationData: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("RESET_CUSTOMIZATION_STORE");
  }
};
const getters = {
  customizationsList: state => state.customizationsList,
  selectedCustomizations: state => state.selectedCustomizations,
  customizationTotalPrice: state => state.customizationTotalPrice,
  selectedChargeableCustomizations: state =>
    state.selectedChargeableCustomizations,
  customizationAdditionalTaxes: state => state.customizationAdditionalTaxes,
  customizationTaxesPrice: state => state.customizationTaxesPrice
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/CustomizationStore.js